module.exports = __webpack_public_path__ + "img/badge-2.7e2fc622.svg";